import { Getter } from "vuex";
import { IState } from './state';

const pages: Getter<IState, IState> = (state) => {
    return Math.ceil(state.total / state.count)
};

export default {
	pages
}
